import Rest2 from '../Services/Rest2'
import {store} from '../store/store'
/**
 * @typedef {ProductService}
 */
export default class ProductService{

    constructor() {
        this.resource = "/product"
        this.http = Rest2.build(store.getters.token, this.resource);
    }

    static build() {
        return new this();
    }

    getAll(){
        return this.http.get('/all');
    }

    getOne(product_id){
        return this.http.get(`/${product_id}`)    
    }

    /**
     * Deleta um produto
     * @param {*} product_id 
     */
    delete(product_id){
        return this.http.delete(`/delete/${product_id}`);    
    }

    
    saveMetadata(params){
        return this.http.post('/save', params)
    }

    sendAudioFile(params, http_options){
        var form_data = new FormData();
        for ( var key in params ) {
            form_data.append(key, params[key]);
        }
        return this.http.postFormData('/save/audio', form_data, http_options)
    }

    sendCover(params){
        var form_data = new FormData();
        for ( var key in params ) {
        form_data.append(key, params[key]);
        }
        return this.http.post('/save/cover', form_data)
    }
}